module.exports = __webpack_public_path__ + "static/tfk-privacy-bf68a3b93a7b36ff2f16547135e9a6c1.pdf";